import React from 'react'
import ChooseImportType from 'components/Imports/ChooseImportType';
import { Layout, NavigationHeader, Button } from '@driftt/tide-core'

const UploadPage = (props) => {
  return (
    <>
      <NavigationHeader title="Import contacts">
        <Button type="tertiary" className="choose-import--log-button" href="/contacts/imports/logs">Import logs</Button>
      </NavigationHeader>
      <Layout>
        <ChooseImportType {...props} />
      </Layout>
    </>
  )
}

export default UploadPage
